export default "__VITE_ASSET__Db2Qgk3j__"